import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import RootLayout from '../Pages/RootLayout';
import Dashboard from '../Pages/Dashboard';
import AllOrders from '../Pages/Orders';
import AddOrders from '../Pages/Orders/AddOrders';
import ConfirmOrders from '../Pages/Orders/ConfirmOrders';
import User from '../Pages/User';
import Login from '../Pages/Auth/Login';
import { useSelector } from 'react-redux';
import PrintOrders from '../Pages/Orders/PrintOrders';
import BulkUpdate from '../Pages/Orders/BulkUpdate';
import SuperAdminLayout from '../Pages/SuperAdmin/SuperAdminLayout';
import SuperDashboard from '../Pages/SuperAdmin/SuperDashboard';
import AddFranchise from '../Pages/SuperAdmin/AddFranchise';
import SuperLogin from '../Pages/SuperAdmin/SuperLogin';
import OrderDashboard from '../Components/OrderDashboard';
import OrderAnalyticsDashboard from '../Components/OrderAnalyticsDashboard';
import DashboardV2 from '../Pages/Dashboard/DashboardV2';
import OrderOverviewDashboard from '../Components/OrderOverviewDashboard';
import OrderAnalyticsDashboardBackup from '../Components/dashboardBackup';
import Settings from '../Pages/Settings';
import TrashedOrders from '../Pages/Orders/TrachedOrders';
import ThemeLoader from '../Components/ThemeLoader';
import Postage from '../Pages/Postage';
import Inventory from '../Pages/Inventory';
import Templates from '../Pages/SuperAdmin/Templates';


function Routing() {

    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);

    const isSuperAdmin = token && role === "superAdmin";
    const isAdmin = token && role === "admin";
    const isUser = token && role === "user";


    return (
        <BrowserRouter>
            <Routes>

                {/* ✅ Login Routes */}
                {!token && (
                    <>
                        <Route path="/login" element={<Login />} />
                        <Route path="*" element={<Navigate to="/login" />} />
                        <Route path="sa-login" element={<SuperLogin />} />
                    </>
                )}

                {/* ✅ Super Admin Routes (COMPLETELY SEPARATE) */}
                {isSuperAdmin && (
                    <>
                        <Route path="/super-admin" element={<SuperAdminLayout />}>
                            <Route path="dashboard" element={<OrderAnalyticsDashboard />} />
                            <Route path="overview" element={<OrderOverviewDashboard />} />
                            <Route path="franchise" element={<AddFranchise />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="templates" element={<Templates />} />

                        </Route>

                        <Route path="*" element={<Navigate to="/super-admin/dashboard" />} />
                    </>
                )}

                {/* ✅ Admin Routes */}
                {isAdmin && (
                    <>
                        <Route path="/portal" element={<RootLayout />}>
                            {/* <Route path="dashboard" element={<Dashboard />} /> */}
                            <Route path="dashboard" element={<OrderAnalyticsDashboard />} />
                            {/* <Route path="dashboard" element={<OrderAnalyticsDashboardBackup />} /> */}
                            <Route path="update-orders" element={<AllOrders />} />
                            <Route path="add-orders" element={<AddOrders />} />
                            <Route path="print-orders" element={<PrintOrders />} />
                            <Route path="confirm-orders" element={<ConfirmOrders />} />
                            <Route path="user" element={<User />} />
                            <Route path="overview" element={<OrderOverviewDashboard />} />
                            <Route path="settings" element={<Settings />} />
                            <Route path="bulk-update" element={<BulkUpdate />} />
                            <Route path="trashed-orders" element={<TrashedOrders />} />
                            <Route path="postage" element={<Postage />} />
                            <Route path="inventory" element={<Inventory />} />



                        </Route>

                        <Route path="*" element={<Navigate to="/portal/dashboard" />} />
                    </>
                )}

                {/* ✅ User Routes */}
                {isUser && (
                    <>
                        <Route path="/portal" element={<RootLayout />}>
                            <Route path="update-orders" element={<AllOrders />} />
                            <Route path="add-orders" element={<AddOrders />} />
                            <Route path="print-orders" element={<PrintOrders />} />
                            <Route path="confirm-orders" element={<ConfirmOrders />} />
                            <Route path="bulk-update" element={<BulkUpdate />} />
                        </Route>

                        <Route path="*" element={<Navigate to="/portal/update-orders" />} />
                    </>
                )}

            </Routes>
        </BrowserRouter>
    );
}

export default Routing;